import { ImageItem, TextItem } from "@exibra/shared";
import { t } from "i18next";
import { v4 as uuidv4 } from "uuid";

const DEFAULT_IMAGE =
    "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png";

export const getDefaultTextItem = (
    nextLayerNumber: number = 1,
    x: number = 0,
    y: number = 0,
): TextItem => {
    return {
        id: uuidv4(),
        type: "text",
        name: t(`templates.layerTypes.text`) + " " + nextLayerNumber,
        style: {
            fontSize: 36,
            font: "Arial",
            bold: false,
            italic: false,
            align: "left",
        },
        x,
        y,
        scaleX: 1,
        scaleY: 1,
        rotation: 0,
        width: 100,
        height: 100,
        text: t(`templates.layerTypes.text`),
    };
};

export const getDefaultImageItem = (
    nextLayerNumber: number = 1,
    x: number = 0,
    y: number = 0,
    imageUrl: string = DEFAULT_IMAGE,
): ImageItem => {
    return {
        id: uuidv4(),
        type: "image",
        name: t(`templates.layerTypes.image`) + " " + nextLayerNumber,
        imageUrl,
        x,
        y,
        scaleX: 1,
        scaleY: 1,
        rotation: 0,
        width: 100,
        height: 100,
    };
};
